module.exports = __webpack_public_path__ + "img/ioniq.efe3bf4b.png";